import * as angular from 'angular';
import {SplitService} from "../../commons/services/split-service.service";
import {SupplyResourceEnum} from "../types/supply-resource.enum";
import {RouteExportRowType} from "../../routes/enums/route-export-row.type";
import {ChangeRouteResourceQueryModelModel} from "../../routes/models/change-route-resource-query-model.model";

export class LeanPlanningRequestsService {
  constructor(private PlanningRoutesAPI, private splitService: SplitService,
              private $planningRoutes, private RoutesPageableAPI, private $routesPageable, private $translate) {
  }


  getRoutes(ids?, tags?, expandTasks?, expandTasksExt?, expandServices?) {
    const api = this.PlanningRoutesAPI.actions.getRoutes;
    return this.$$callRoutes(api, {
      ids: ids,
      tags: tags,
      expandTasks: expandTasks,
      expandTasksExt: expandTasksExt,
      expandServices: expandServices
    }, {}, {})
  }

  createRoute(payload) {
    const api = this.PlanningRoutesAPI.actions.createRouteNew;
    const creatingRouteOnlyFromGeoServer = this.splitService.isCreatingRouteOnlyFromGeoServer()
    return this.$$callRoutes(api, {onlyOptimized: creatingRouteOnlyFromGeoServer}, payload, {})
  }

  editGroupSequence(groupId, orderedRouteIds) {
    const api = this.PlanningRoutesAPI.actions.editGroupSequence;
    return this.$$callRoutes(api, {}, {
      orderedRouteIds: orderedRouteIds,
    }, {groupId: groupId})
  }

  getSuggestedServices(routeId, areaIds) {
    const api = this.PlanningRoutesAPI.actions.getSuggestedServices;
    return this.$$callRoutes(api, {areaIds: areaIds}, {inRoute: false}, {id: routeId})
  }

  getAssignSuggestions(routeId, type, query) {
    const api = this.PlanningRoutesAPI.actions.getAssignSuggestions;
    return this.$$callRoute(api, {type: type, query: query}, {}, {}, routeId)
  }

  addServicesToRoute(deliveryIds?, routeId?, assignAddedDeliveries?) {
    const api = this.PlanningRoutesAPI.actions.putDelivery;
    return this.$$callRoute(api, {deliveryIds: deliveryIds, assignDeliveries: assignAddedDeliveries}, {}, {}, routeId);
  }

  addServicesToRouteSyncTimeWindow(payload) {
    const api = this.PlanningRoutesAPI.actions.addServicesToRouteSyncTimeWindow;
    return this.$$callRoutes(api, {}, payload, {});
  }

  createRouteFromServicesSyncTimeWindow(payload) {
    const api = this.PlanningRoutesAPI.actions.createRouteFromServicesSyncTimeWindow;
    return this.$$callRoutes(api, {}, payload, {});
  }


  removeDeliveryFromRoute(deliveryIds?, routeId?, assignAddedDeliveries?) {
    const api = this.PlanningRoutesAPI.actions.removeDelivery;
    return this.$$callRoute(api, {deliveryIds: deliveryIds, resetDeliveries: assignAddedDeliveries}, {}, {}, routeId);
  }

  assignRouteToAgent(routeId?, agentId?, assignAll?) {
    const api = this.PlanningRoutesAPI.actions.assignRoute;
    return this.$$callRoute(api, {assignAllServicesToAgent: assignAll}, {}, {agentId: agentId}, routeId)
  }

  assignRoutesToAgent(routeIds: string[], agentId: string, assignAllServicesToAgent?: boolean) {
    const api = this.PlanningRoutesAPI.actions.assignRoutes;
    return this.$$callRoutes(api, {routeIds: routeIds, assignAllServicesToAgent: assignAllServicesToAgent}, {}, {agentId: agentId})
  }

  editRoutes(data?, assignServices?, resetServices?) {
    const api = this.PlanningRoutesAPI.actions.editRoutes;
    return this.$$callRoutes(api, {assignServices: assignServices, resetServices: resetServices}, data, {})
  }


  optimizeRoute(routeId) {
    const api = this.PlanningRoutesAPI.actions.optimizeRoute;
    return this.$$callRoute(api, {}, {}, {id: routeId})
  }


  updateRouteSettings(routeId, route) {
    const api = this.PlanningRoutesAPI.actions.updateRouteSettings;
    return this.$$callRoute(api, {}, route, {id: routeId})
  }


  exportRoutes(ids?, excludedIds?, branchIds?, areaIds?, statuses?, from?, to?, query?, agentSkills?: string[], routeExportRowType?: RouteExportRowType, tags?: string[], resourceIds?: string[], depotIds?: string[], resourceTags?: string[], vehicleTypeIds?: string[], relationTypes?: string[]) {
    const siteId = this.splitService.getSiteId();
    const api = this.PlanningRoutesAPI.actions.exportRoutes;
    const payload: { fieldTranslationMap?: { [key: string]: string; } } = (routeExportRowType === RouteExportRowType.DROPOFFS || routeExportRowType === RouteExportRowType.GROUPED_DROPOFFS) ? {
      fieldTranslationMap: {
        routeId: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.routeId"),
        routeName: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.routeName"),
        notBefore: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.notBefore"),
        notAfter: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.notAfter"),
        depotName: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.depotName"),
        referenceIds: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.referenceIds"),
        pickingTime: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.pickingTime"),
        sequence: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.sequence"),
        serviceExternalIds: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.serviceExternalIds"),
        accountExternalId: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.accountExternalId"),
        accountName: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.accountName"),
        fullAddress: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.fullAddress"),
        programName: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.programName"),
        packageTypeName: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.packageTypeName"),
        serviceTotalPallets: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.serviceTotalPallets"),
        totalRoutePallets: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.totalRoutePallets"),
        totalRouteWeight: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.totalRouteWeight"),
        totalRouteVolume:  this.$translate.instant("EXPORT_ROUTES_DROPOFFS.totalRouteVolume"),
        agentName:  this.$translate.instant("EXPORT_ROUTES_DROPOFFS.agentName"),
        agentPhoneNumber: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.agentPhoneNumber"),
        resourceName: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.resourceName"),
        timeWindow: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.timeWindow"),
        routeSequence: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.routeSequence"),
        serviceTotalWeight: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.serviceTotalWeight"),
        vehicleType: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.vehicleType"),
        pickupStops: this.$translate.instant("EXPORT_ROUTES_DROPOFFS.pickupStops"),
      }
    } : {};

    if (payload.fieldTranslationMap && routeExportRowType === RouteExportRowType.GROUPED_DROPOFFS) {
      payload.fieldTranslationMap.city = this.$translate.instant("EXPORT_ROUTES_DROPOFFS.city");
    }

    return this.$$callRoutes(api, {
      siteId: siteId,
      branchIds: branchIds,
      depotIds: depotIds,
      areaIds: areaIds,
      status: statuses,
      from: from,
      to: to,
      query: query,
      ids: ids,
      excludedIds: excludedIds,
      skill: agentSkills,
      routeExportRowType: routeExportRowType,
      allocationIds: resourceIds,
      tags: tags,
      resourceTags: resourceTags,
      vehicleTypeIds: vehicleTypeIds,
      relationTypes: relationTypes,
      zoneId: this.splitService.getTimeZone()
    }, payload, {})
  }

  exportIntegrationRoutes(ids, branchIds?, areaIds?, statuses?, from?, to?, query?, agentSkills?: string[], tags?: string[], resourceIds?: string[]) {
    const siteId = this.splitService.getSiteId();
    const api = this.PlanningRoutesAPI.actions.exportIntegrationRoutes;
    return this.$$callRoutes(api, {
      siteId: siteId,
      branchIds: branchIds,
      areaIds: areaIds,
      status: statuses,
      from: from,
      to: to,
      query: query,
      ids: ids,
      skill: agentSkills,
      tags: tags,
      resourceIds: resourceIds,
      zoneId: this.splitService.getTimeZone()
    }, {}, {providerType: 'IntegrationLayer'})
  }

  getPageableRoutes(params) {
    if (!params) {
      params = {};
    }
    const api = this.RoutesPageableAPI.actions.getRoutes;
    return this.$$callPageable(api, params, {}, {});
  }

  recreateRoute(routeId, resourceAllocationId, allocationInstanceId, supplyResourceSource, allocationTimeWindowId, queries?: ChangeRouteResourceQueryModelModel) {
    const api = this.PlanningRoutesAPI.actions.recreateRoute;
    const creatingRouteOnlyFromGeoServer = this.splitService.isCreatingRouteOnlyFromGeoServer()

    if (!!queries) {
      queries.onlyOptimized = creatingRouteOnlyFromGeoServer;
    } else {
      queries = {onlyOptimized: creatingRouteOnlyFromGeoServer};
    }

    return this.$$callRoute(api, queries, {
      resourceAllocationId: resourceAllocationId,
      allocationInstanceId: allocationInstanceId,
      supplyResourceSource: supplyResourceSource,
      allocationTimeWindowId: allocationTimeWindowId,
    }, {id: routeId});
  }

  editBlockedState(routeId, block) {
    const api = this.PlanningRoutesAPI.actions.editBlockedState;
    return this.$$callRoute(api, {block: block}, {}, {id: routeId})
  }

  validateAssignment(routeId, serviceIds) {
    const api = this.PlanningRoutesAPI.actions.validateAssignment;
    return this.$$callRoutes(api, {}, {
      routeId: routeId,
      serviceIds: serviceIds
    }, {})
  }


  // ******************************
  //        Internal methods
  // ******************************


  // private $$call(_apiCall, _params, _data, _options) {
  //   return this.$leanPlans().$call(_apiCall, _params, _data, _options);
  // }

  private $$callRoute(_apiCall, _params, _data, _options, _id?: any) {
    return this.$planningRoutes(_id).$call(_apiCall, _params, _data, _options);
  }

  private $$callRoutes(_apiCall, _params, _data, _options) {
    return this.$planningRoutes().$call(_apiCall, _params, _data, _options);
  }

  private $$callPageable(_apiCall, _params, _data, _options) {
    return this.$routesPageable().$call(_apiCall, _params, _data, _options);
  }

}


angular
  .module('bringoz.admin.lean-planning')
  .service('leanPlanningRequestsService', LeanPlanningRequestsService);
